export default __webpack_public_path__ + "static/media/Bilo3-10.5629856d.jpg";